import React from 'react';
import { Sidebar } from './Sidebar.jsx';
import { Breadcrumb } from './Breadcrumb.jsx';
import { Logo } from '../brand/Logo.jsx';
import { TenantWatermark } from '../brand/TenantWatermark.jsx';

function getBp() {
  if (typeof window === 'undefined') return 'desktop';
  const w = window.innerWidth;
  return w < 768 ? 'mobile' : w < 1100 ? 'tablet' : 'desktop';
}
function useBp(forced) {
  const [bp, setBp] = React.useState(getBp);
  React.useEffect(() => { const f = () => setBp(getBp()); window.addEventListener('resize', f); return () => window.removeEventListener('resize', f); }, []);
  return forced || bp;
}
const iconBtn = { width: 44, height: 44, border: 0, borderRadius: '50%', background: 'transparent', display: 'grid', placeItems: 'center', fontSize: 22, color: 'var(--text-1)', cursor: 'pointer', flex: 'none' };
const Ph = ({ n }) => <iconify-icon icon={`ph:${n}-duotone`}></iconify-icon>;

export function AppShell({ tenant, user, groups, activeKey, onSelect, crumbs = [], title, onBack, actions, mobileActions, assistant, breakpoint, maxWidth = 1240, children }) {
  const bp = useBp(breakpoint);
  const mobile = bp === 'mobile', tablet = bp === 'tablet';
  const pad = mobile ? 16 : tablet ? 24 : 32;
  const layout = { bp, mobile, tablet, desktop: bp === 'desktop', pad };
  const [drawer, setDrawer] = React.useState(false);
  const pageTitle = title || crumbs[crumbs.length - 1] || '';
  const watermark = tenant && <TenantWatermark tenant={tenant} position="inline" size={28} opacity={0.32} />;
  const full = <Sidebar brand={<div style={{ padding: '0 8px' }}><Logo size={30} /></div>} tenant={tenant} groups={groups} activeKey={activeKey} onSelect={(k) => { setDrawer(false); onSelect && onSelect(k); }} user={user} />;
  return (
    <div style={{ display: 'flex', height: '100%', background: 'var(--page-bg)', fontFamily: 'var(--font-body)' }}>
      <style>{'@keyframes eq-shell-drawer{from{transform:translateX(-100%)}to{transform:none}}'}</style>
      {!mobile && (tablet
        ? <Sidebar collapsed brand={<Logo variant="mark" size={30} />} tenant={tenant} groups={groups} activeKey={activeKey} onSelect={onSelect} user={user} />
        : full)}
      {mobile && drawer && (
        <div style={{ position: 'fixed', inset: 0, zIndex: 60 }}>
          <div onClick={() => setDrawer(false)} style={{ position: 'absolute', inset: 0, background: 'var(--overlay-scrim)' }}></div>
          <div style={{ position: 'absolute', top: 0, bottom: 0, left: 0, boxShadow: 'var(--shadow-overlay)', animation: 'eq-shell-drawer var(--duration-base) var(--ease-out)' }}>{full}</div>
        </div>
      )}
      <main style={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column' }}>
        <div style={{ height: mobile ? 56 : 64, flex: 'none', display: 'flex', alignItems: 'center', gap: mobile ? 8 : 16, padding: `0 ${mobile ? 8 : pad}px`, borderBottom: '1px solid var(--border)', background: mobile ? 'var(--surface-1)' : 'transparent' }}>
          {mobile ? (
            <>
              {onBack
                ? <button type="button" aria-label="Back" onClick={onBack} style={iconBtn}><Ph n="arrow-left" /></button>
                : <button type="button" aria-label="Menu" onClick={() => setDrawer(true)} style={iconBtn}><Ph n="list" /></button>}
              <div style={{ flex: 1, minWidth: 0, fontWeight: 600, fontSize: 16, color: 'var(--text-1)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{pageTitle}</div>
            </>
          ) : (
            <div onClick={onBack} style={{ cursor: onBack ? 'pointer' : 'default', minWidth: 0 }}><Breadcrumb items={crumbs} /></div>
          )}
          <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: 10, flex: 'none' }}>{mobile && mobileActions !== undefined ? mobileActions : actions}</div>
        </div>
        <div style={{ flex: 1, overflowY: 'auto' }}>
          <div style={{ padding: `${mobile ? 16 : 28}px ${pad}px ${mobile ? 24 : 72}px`, display: 'grid', gap: mobile ? 16 : 20, maxWidth }}>
            {typeof children === 'function' ? children(layout) : children}
          </div>
          {mobile && <div style={{ display: 'flex', justifyContent: 'center', padding: `8px 0 ${assistant ? 104 : 24}px` }}>{watermark}</div>}
        </div>
        {!mobile && <div style={{ height: 48, flex: 'none', display: 'flex', alignItems: 'center', padding: `0 ${pad}px` }}>{watermark}</div>}
      </main>
      {assistant}
    </div>
  );
}
